// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep mat-expansion-panel-header .mat-expansion-indicator {
  display: none;
}

::ng-deep mat-icon {
  color: white !important;
}

table {
  td {
    text-align: center;
  }
}

.employee-picture {
  max-width: 200px;
  max-height: 200px;
  display: block;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  object-fit: cover;
}

.upload-button-container {
  margin-top: 10px;
}

.bg-red {
  background-color: red;
}

.bg-white {
  background-color: white;
}

.picklist-inline-label {
  padding-top: 3.5%;
}
`, "",{"version":3,"sources":["webpack://./projects/ert/src/app/ert-user/ert-user-view/ert-user-view.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["::ng-deep mat-expansion-panel-header .mat-expansion-indicator {\n  display: none;\n}\n\n::ng-deep mat-icon {\n  color: white !important;\n}\n\ntable {\n  td {\n    text-align: center;\n  }\n}\n\n.employee-picture {\n  max-width: 200px;\n  max-height: 200px;\n  display: block;\n  margin-bottom: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 5px;\n  object-fit: cover;\n}\n\n.upload-button-container {\n  margin-top: 10px;\n}\n\n.bg-red {\n  background-color: red;\n}\n\n.bg-white {\n  background-color: white;\n}\n\n.picklist-inline-label {\n  padding-top: 3.5%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
